export interface CountryDetail {
  name: string;
  id: number;
  abbreviation: string;
}
export interface Country {
  [key: string]: CountryDetail[];
}
export const COUNTRIES: Country = {
  AF: [
    {
      name: 'Algeria',
      id: 3,
      abbreviation: 'DZ',
    },
    {
      name: 'Angola',
      id: 6,
      abbreviation: 'AO',
    },
    {
      name: 'Benin',
      id: 22,
      abbreviation: 'BJ',
    },
    {
      name: 'Botswana',
      id: 27,
      abbreviation: 'BW',
    },
    {
      name: 'Burkina Faso',
      id: 32,
      abbreviation: 'BF',
    },
    {
      name: 'Burundi',
      id: 34,
      abbreviation: 'BI',
    },
    {
      name: 'Cameroon',
      id: 36,
      abbreviation: 'CM',
    },
    {
      name: 'Cape Verde',
      id: 38,
      abbreviation: 'CV',
    },
    {
      name: 'Central African Republic',
      id: 40,
      abbreviation: 'CF',
    },
    {
      name: 'Chad',
      id: 41,
      abbreviation: 'TD',
    },
    {
      name: 'Comoros',
      id: 46,
      abbreviation: 'KM',
    },
    {
      name: 'Congo, Democratic Republic (Kinshasa)',
      id: 176,
      abbreviation: 'CG',
    },
    {
      name: 'Congo, Replublic of the (Brazzaville)',
      id: 47,
      abbreviation: 'CD',
    },
    {
      name: 'Djibouti',
      id: 56,
      abbreviation: 'DJ',
    },
    {
      name: 'Egypt',
      id: 61,
      abbreviation: 'EG',
    },
    {
      name: 'Equatorial Guinea',
      id: 63,
      abbreviation: 'GQ',
    },
    {
      name: 'Eritrea',
      id: 64,
      abbreviation: 'ER',
    },
    {
      name: 'Ethiopia',
      id: 66,
      abbreviation: 'ET',
    },
    {
      name: 'Gabon',
      id: 75,
      abbreviation: 'GA',
    },
    {
      name: 'Gambia',
      id: 76,
      abbreviation: 'GM',
    },
    {
      name: 'Ghana',
      id: 79,
      abbreviation: 'GH',
    },
    {
      name: 'Guinea',
      id: 87,
      abbreviation: 'GN',
    },
    {
      name: 'Guinea-Bissau',
      id: 88,
      abbreviation: 'GW',
    },
    {
      // eslint-disable-next-line @typescript-eslint/quotes
      name: `Ivory Coast (Cote d'Ivoire)`,
      id: 103,
      abbreviation: 'CI',
    },
    {
      name: 'Kenya',
      id: 108,
      abbreviation: 'KE',
    },
    {
      name: 'Lesotho',
      id: 118,
      abbreviation: 'LS',
    },
    {
      name: 'Liberia',
      id: 119,
      abbreviation: 'LR',
    },
    {
      name: 'Libya',
      id: 120,
      abbreviation: 'LY',
    },
    {
      name: 'Madagascar',
      id: 126,
      abbreviation: 'MG',
    },
    {
      name: 'Malawi',
      id: 127,
      abbreviation: 'MW',
    },
    {
      name: 'Mali',
      id: 130,
      abbreviation: 'ML',
    },
    {
      name: 'Mauritania',
      id: 134,
      abbreviation: 'MR',
    },
    {
      name: 'Mauritius',
      id: 135,
      abbreviation: 'MU',
    },
    {
      name: 'Mayotte',
      id: 136,
      abbreviation: 'YT',
    },
    {
      name: 'Morocco',
      id: 145,
      abbreviation: 'MA',
    },
    {
      name: 'Mozambique',
      id: 146,
      abbreviation: 'MZ',
    },
    {
      name: 'Namibia',
      id: 148,
      abbreviation: 'NA',
    },
    {
      name: 'Niger',
      id: 156,
      abbreviation: 'NE',
    },
    {
      name: 'Nigeria',
      id: 157,
      abbreviation: 'NG',
    },
    {
      name: 'Rwanda',
      id: 180,
      abbreviation: 'RW',
    },
    {
      name: 'Saint Helena',
      id: 181,
      abbreviation: 'SH',
    },
    {
      name: 'Sao Tome and Principe',
      id: 187,
      abbreviation: 'ST',
    },
    {
      name: 'Senegal',
      id: 189,
      abbreviation: 'SN',
    },
    {
      name: 'Seychelles',
      id: 190,
      abbreviation: 'SC',
    },
    {
      name: 'Sierra Leone',
      id: 191,
      abbreviation: 'SL',
    },
    {
      name: 'Somalia',
      id: 196,
      abbreviation: 'SO',
    },
    {
      name: 'South Africa',
      id: 197,
      abbreviation: 'ZA',
    },
    {
      name: 'South Sudan',
      id: 246,
      abbreviation: 'SS',
    },
    {
      name: 'Sudan',
      id: 200,
      abbreviation: 'SD',
    },
    {
      name: 'Swaziland',
      id: 203,
      abbreviation: 'SZ',
    },
    {
      name: 'Tanzania',
      id: 209,
      abbreviation: 'TZ',
    },
    {
      name: 'Togo',
      id: 211,
      abbreviation: 'TG',
    },
    {
      name: 'Tunisia',
      id: 215,
      abbreviation: 'TN',
    },
    {
      name: 'Uganda',
      id: 220,
      abbreviation: 'UG',
    },
    {
      name: 'Western Sahara',
      id: 234,
      abbreviation: 'EH',
    },
    {
      name: 'Zambia',
      id: 238,
      abbreviation: 'ZM',
    },
    {
      name: 'Zimbabwe',
      id: 239,
      abbreviation: 'ZW',
    },
  ],
  AS: [
    {
      name: 'Bangladesh',
      id: 17,
      abbreviation: 'BD',
    },
    {
      name: 'Bhutan',
      id: 24,
      abbreviation: 'BT',
    },
    {
      name: 'British Indian Ocean Territory',
      id: 252,
      abbreviation: 'IO',
    },
    {
      name: 'Brunei',
      id: 30,
      abbreviation: 'BN',
    },
    {
      name: 'Burma (Myanmar)',
      id: 33,
      abbreviation: 'MM',
    },
    {
      name: 'Cambodia',
      id: 35,
      abbreviation: 'KH',
    },
    {
      name: 'China',
      id: 44,
      abbreviation: 'CN',
    },
    {
      name: 'Guam',
      id: 85,
      abbreviation: 'GU',
    },
    {
      name: 'Hong Kong',
      id: 92,
      abbreviation: 'HK',
    },
    {
      name: 'India',
      id: 95,
      abbreviation: 'IN',
    },
    {
      name: 'Indonesia',
      id: 96,
      abbreviation: 'ID',
    },
    {
      name: 'Japan',
      id: 105,
      abbreviation: 'JP',
    },
    {
      name: 'Korea, North',
      id: 111,
      abbreviation: 'KP',
    },
    {
      name: 'Korea, South',
      id: 112,
      abbreviation: 'KR',
    },
    {
      name: 'Laos',
      id: 115,
      abbreviation: 'LA',
    },
    {
      name: 'Macau (Macao)',
      id: 124,
      abbreviation: 'MO',
    },
    {
      name: 'Malaysia',
      id: 128,
      abbreviation: 'MY',
    },
    {
      name: 'Maldives',
      id: 129,
      abbreviation: 'MV',
    },
    {
      name: 'Mongolia',
      id: 142,
      abbreviation: 'MN',
    },
    {
      name: 'Nepal',
      id: 150,
      abbreviation: 'NP',
    },
    {
      name: 'Northern Mariana Islands',
      id: 160,
      abbreviation: 'MP',
    },
    {
      name: 'Pakistan',
      id: 163,
      abbreviation: 'PK',
    },
    {
      name: 'Palau',
      id: 164,
      abbreviation: 'PW',
    },
    {
      name: 'Papua New Guinea',
      id: 167,
      abbreviation: 'PG',
    },
    {
      name: 'Philippines',
      id: 170,
      abbreviation: 'PH',
    },
    {
      name: 'Singapore',
      id: 192,
      abbreviation: 'SG',
    },
    {
      name: 'Solomon Islands',
      id: 195,
      abbreviation: 'SB',
    },
    {
      name: 'Sri Lanka',
      id: 199,
      abbreviation: 'LK',
    },
    {
      name: 'Taiwan',
      id: 207,
      abbreviation: 'TW',
    },
    {
      name: 'Thailand',
      id: 210,
      abbreviation: 'TH',
    },
    {
      name: 'Timor-Leste',
      id: 59,
      abbreviation: 'TL',
    },
    {
      name: 'Vietnam',
      id: 231,
      abbreviation: 'VN',
    },
  ],
  EU: [
    {
      name: 'Akrotiri',
      id: 249,
      abbreviation: '(blank)',
    },
    {
      name: 'Albania',
      id: 2,
      abbreviation: 'AL',
    },
    {
      name: 'Andorra',
      id: 5,
      abbreviation: 'AD',
    },
    {
      name: 'Armenia',
      id: 10,
      abbreviation: 'AM',
    },
    {
      name: 'Austria',
      id: 13,
      abbreviation: 'AT',
    },
    {
      name: 'Azerbaijan',
      id: 14,
      abbreviation: 'AZ',
    },
    {
      name: 'Belarus',
      id: 21,
      abbreviation: 'BY',
    },
    {
      name: 'Belgium',
      id: 19,
      abbreviation: 'BE',
    },
    {
      name: 'Bosnia and Herzegovina',
      id: 26,
      abbreviation: 'BA',
    },
    {
      name: 'Bulgaria',
      id: 31,
      abbreviation: 'BG',
    },
    {
      name: 'Channel Islands',
      id: 42,
      abbreviation: '(blank)',
    },
    {
      name: 'Croatia',
      id: 51,
      abbreviation: 'HR',
    },
    {
      name: 'Cyprus',
      id: 53,
      abbreviation: 'CY',
    },
    {
      name: 'Czech Republic',
      id: 54,
      abbreviation: 'CZ',
    },
    {
      name: 'Denmark',
      id: 55,
      abbreviation: 'DK',
    },
    {
      name: 'Dhekelia',
      id: 251,
      abbreviation: '(blank)',
    },
    {
      name: 'Estonia',
      id: 65,
      abbreviation: 'EE',
    },
    {
      name: 'Faroe Islands',
      id: 67,
      abbreviation: 'FO',
    },
    {
      name: 'Finland',
      id: 70,
      abbreviation: 'FI',
    },
    {
      name: 'France',
      id: 71,
      abbreviation: 'FR',
    },
    {
      name: 'Georgia',
      id: 77,
      abbreviation: 'GE',
    },
    {
      name: 'Germany',
      id: 78,
      abbreviation: 'DE',
    },
    {
      name: 'Gibraltar',
      id: 80,
      abbreviation: 'GI',
    },
    {
      name: 'Greece',
      id: 81,
      abbreviation: 'GR',
    },
    {
      name: 'Guernsey',
      id: 243,
      abbreviation: 'GG',
    },
    {
      name: 'Hungary',
      id: 93,
      abbreviation: 'HU',
    },
    {
      name: 'Iceland',
      id: 94,
      abbreviation: 'IS',
    },
    {
      name: 'Ireland',
      id: 99,
      abbreviation: 'IE',
    },
    {
      name: 'Isle of Man',
      id: 100,
      abbreviation: 'IM',
    },
    {
      name: 'Italy',
      id: 102,
      abbreviation: 'IT',
    },
    {
      name: 'Jersey',
      id: 244,
      abbreviation: 'JE',
    },
    {
      name: 'Kazakhstan',
      id: 107,
      abbreviation: 'KZ',
    },
    {
      name: 'Kosovo',
      id: 240,
      abbreviation: 'XK',
    },
    {
      name: 'Kyrgyzstan',
      id: 114,
      abbreviation: 'KG',
    },
    {
      name: 'Latvia',
      id: 116,
      abbreviation: 'LV',
    },
    {
      name: 'Liechtenstein',
      id: 121,
      abbreviation: 'LI',
    },
    {
      name: 'Lithuania',
      id: 122,
      abbreviation: 'LT',
    },
    {
      name: 'Luxembourg',
      id: 123,
      abbreviation: 'LU',
    },
    {
      name: 'Macedonia',
      id: 125,
      abbreviation: 'MK',
    },
    {
      name: 'Malta',
      id: 131,
      abbreviation: 'MT',
    },
    {
      name: 'Moldova',
      id: 140,
      abbreviation: 'MD',
    },
    {
      name: 'Monaco',
      id: 141,
      abbreviation: 'MC',
    },
    {
      name: 'Montenegro',
      id: 143,
      abbreviation: 'ME',
    },
    {
      name: 'Netherlands',
      id: 151,
      abbreviation: 'NL',
    },
    {
      name: 'Norway',
      id: 161,
      abbreviation: 'NO',
    },
    {
      name: 'Poland',
      id: 172,
      abbreviation: 'PL',
    },
    {
      name: 'Portugal',
      id: 173,
      abbreviation: 'PT',
    },
    {
      name: 'Romania',
      id: 178,
      abbreviation: 'RO',
    },
    {
      name: 'Russia',
      id: 179,
      abbreviation: 'RU',
    },
    {
      name: 'San Marino',
      id: 186,
      abbreviation: 'SM',
    },
    {
      name: 'Serbia',
      id: 237,
      abbreviation: 'RS',
    },
    {
      name: 'Slovakia',
      id: 193,
      abbreviation: 'SK',
    },
    {
      name: 'Slovenia',
      id: 194,
      abbreviation: 'SI',
    },
    {
      name: 'Spain',
      id: 198,
      abbreviation: 'ES',
    },
    {
      name: 'Svalbard Islands',
      id: 202,
      abbreviation: 'SJ',
    },
    {
      name: 'Sweden',
      id: 204,
      abbreviation: 'SE',
    },
    {
      name: 'Switzerland',
      id: 205,
      abbreviation: 'CH',
    },
    {
      name: 'Tajikistan',
      id: 208,
      abbreviation: 'TJ',
    },
    {
      name: 'Turkey',
      id: 216,
      abbreviation: 'TR',
    },
    {
      name: 'Turkmenistan',
      id: 217,
      abbreviation: 'TM',
    },
    {
      name: 'Ukraine',
      id: 221,
      abbreviation: 'UA',
    },
    {
      name: 'United Kingdom',
      id: 223,
      abbreviation: 'GB',
    },
    {
      name: 'Uzbekistan',
      id: 227,
      abbreviation: 'UZ',
    },
    {
      name: 'Vatican City',
      id: 229,
      abbreviation: 'VA',
    },
  ],
  ME: [
    {
      name: 'Afghanistan',
      id: 1,
      abbreviation: 'AF',
    },
    {
      name: 'Bahrain',
      id: 16,
      abbreviation: 'BH',
    },
    {
      name: 'Gaza Strip',
      id: 248,
      abbreviation: 'XG',
    },
    {
      name: 'Iran',
      id: 97,
      abbreviation: 'IR',
    },
    {
      name: 'Iraq',
      id: 98,
      abbreviation: 'IQ',
    },
    {
      name: 'Israel',
      id: 101,
      abbreviation: 'IL',
    },
    {
      name: 'Jordan',
      id: 106,
      abbreviation: 'JO',
    },
    {
      name: 'Kuwait',
      id: 113,
      abbreviation: 'KW',
    },
    {
      name: 'Lebanon',
      id: 117,
      abbreviation: 'LB',
    },
    {
      name: 'Oman',
      id: 162,
      abbreviation: 'OM',
    },
    {
      name: 'Palestinian Territory',
      id: 165,
      abbreviation: 'PS',
    },
    {
      name: 'Qatar',
      id: 175,
      abbreviation: 'QA',
    },
    {
      name: 'Saudi Arabia',
      id: 188,
      abbreviation: 'SA',
    },
    {
      name: 'Syria',
      id: 206,
      abbreviation: 'SY',
    },
    {
      name: 'United Arab Emirates',
      id: 222,
      abbreviation: 'AE',
    },
    {
      name: 'West Bank',
      id: 250,
      abbreviation: 'XW',
    },
    {
      name: 'Yemen',
      id: 236,
      abbreviation: 'YE',
    },
  ],
  NA: [
    {
      name: 'Canada',
      id: 37,
      abbreviation: 'CA',
    },
    {
      name: 'Greenland',
      id: 82,
      abbreviation: 'GL',
    },
    {
      name: 'Mexico',
      id: 137,
      abbreviation: 'MX',
    },
    {
      name: 'Puerto Rico',
      id: 174,
      abbreviation: 'PR',
    },
    {
      name: 'Saint Pierre and Miquelon',
      id: 184,
      abbreviation: 'PM',
    },
    {
      name: 'United States',
      id: 224,
      abbreviation: 'US',
    },
    {
      name: 'Virgin Islands, U.S.',
      id: 225,
      abbreviation: 'VI',
    },
  ],
  OC: [
    {
      name: 'American Samoa',
      id: 4,
      abbreviation: 'AS',
    },
    {
      name: 'Australia',
      id: 12,
      abbreviation: 'AU',
    },
    {
      name: 'Cook Islands',
      id: 48,
      abbreviation: 'CK',
    },
    {
      name: 'Fiji',
      id: 69,
      abbreviation: 'FJ',
    },
    {
      name: 'French Polynesia',
      id: 73,
      abbreviation: 'PF',
    },
    {
      name: 'French Southern and Antarctic Lands',
      id: 74,
      abbreviation: 'TF',
    },
    {
      name: 'Kiribati',
      id: 110,
      abbreviation: 'KI',
    },
    {
      name: 'Marshall Islands',
      id: 132,
      abbreviation: 'MH',
    },
    {
      name: 'Micronesia, Federated States of',
      id: 138,
      abbreviation: 'FM',
    },
    {
      name: 'Midway Island',
      id: 139,
      abbreviation: 'UM',
    },
    {
      name: 'Nauru',
      id: 149,
      abbreviation: 'NR',
    },
    {
      name: 'New Caledonia',
      id: 153,
      abbreviation: 'NC',
    },
    {
      name: 'New Zealand',
      id: 154,
      abbreviation: 'NZ',
    },
    {
      name: 'Niue',
      id: 158,
      abbreviation: 'NU',
    },
    {
      name: 'Norfolk Island',
      id: 159,
      abbreviation: 'NF',
    },
    {
      name: 'Pitcairn Islands',
      id: 171,
      abbreviation: 'PN',
    },
    {
      name: 'Samoa (Western Samoa)',
      id: 235,
      abbreviation: 'WS',
    },
    {
      name: 'Tokelau',
      id: 212,
      abbreviation: 'TK',
    },
    {
      name: 'Tonga',
      id: 213,
      abbreviation: 'TO',
    },
    {
      name: 'Tuvalu',
      id: 219,
      abbreviation: 'TV',
    },
    {
      name: 'Vanuatu',
      id: 228,
      abbreviation: 'VU',
    },
    {
      name: 'Wake Island',
      id: 232,
      abbreviation: 'WQ',
    },
    {
      name: 'Wallis and Futuna',
      id: 233,
      abbreviation: 'WF',
    },
  ],
  SA: [
    {
      name: 'Anguilla',
      id: 7,
      abbreviation: 'AI',
    },
    {
      name: 'Antigua and Barbuda',
      id: 8,
      abbreviation: 'AG',
    },
    {
      name: 'Argentina',
      id: 9,
      abbreviation: 'AR',
    },
    {
      name: 'Aruba',
      id: 11,
      abbreviation: 'AW',
    },
    {
      name: 'Bahamas',
      id: 15,
      abbreviation: 'BS',
    },
    {
      name: 'Barbados',
      id: 18,
      abbreviation: 'BB',
    },
    {
      name: 'Belize',
      id: 20,
      abbreviation: 'BZ',
    },
    {
      name: 'Bermuda',
      id: 23,
      abbreviation: 'BM',
    },
    {
      name: 'Bolivia',
      id: 25,
      abbreviation: 'BO',
    },
    {
      name: 'Brazil',
      id: 28,
      abbreviation: 'BR',
    },
    {
      name: 'Caribbean Netherlands',
      id: 152,
      abbreviation: 'BQ',
    },
    {
      name: 'Cayman Islands',
      id: 39,
      abbreviation: 'KY',
    },
    {
      name: 'Chile',
      id: 43,
      abbreviation: 'CL',
    },
    {
      name: 'Colombia',
      id: 45,
      abbreviation: 'CO',
    },
    {
      name: 'Costa Rica',
      id: 49,
      abbreviation: 'CR',
    },
    {
      name: 'Cuba',
      id: 52,
      abbreviation: 'CU',
    },
    {
      name: 'Curacao',
      id: 50,
      abbreviation: 'CW',
    },
    {
      name: 'Dominica',
      id: 57,
      abbreviation: 'DM',
    },
    {
      name: 'Dominican Republic',
      id: 58,
      abbreviation: 'DO',
    },
    {
      name: 'Ecuador',
      id: 60,
      abbreviation: 'EC',
    },
    {
      name: 'El Salvador',
      id: 62,
      abbreviation: 'SV',
    },
    {
      name: 'Falkland Islands (Islas Malvinas)',
      id: 68,
      abbreviation: 'FK',
    },
    {
      name: 'French Guiana',
      id: 72,
      abbreviation: 'GF',
    },
    {
      name: 'Grenada',
      id: 83,
      abbreviation: 'GD',
    },
    {
      name: 'Guadeloupe',
      id: 84,
      abbreviation: 'GP',
    },
    {
      name: 'Guantanamo Bay',
      id: 241,
      abbreviation: '(blank)',
    },
    {
      name: 'Guatemala',
      id: 86,
      abbreviation: 'GT',
    },
    {
      name: 'Guyana',
      id: 89,
      abbreviation: 'GY',
    },
    {
      name: 'Haiti',
      id: 90,
      abbreviation: 'HT',
    },
    {
      name: 'Honduras',
      id: 91,
      abbreviation: 'HN',
    },
    {
      name: 'Jamaica',
      id: 104,
      abbreviation: 'JM',
    },
    {
      name: 'Martinique',
      id: 133,
      abbreviation: 'MQ',
    },
    {
      name: 'Montserrat',
      id: 144,
      abbreviation: 'MS',
    },
    {
      name: 'Nicaragua',
      id: 155,
      abbreviation: 'NI',
    },
    {
      name: 'Panama',
      id: 166,
      abbreviation: 'PA',
    },
    {
      name: 'Paraguay',
      id: 168,
      abbreviation: 'PY',
    },
    {
      name: 'Peru',
      id: 169,
      abbreviation: 'PE',
    },
    {
      name: 'Saint Barthelemy',
      id: 242,
      abbreviation: 'BL',
    },
    {
      name: 'Saint Kitts and Nevis',
      id: 182,
      abbreviation: 'KN',
    },
    {
      name: 'Saint Lucia',
      id: 183,
      abbreviation: 'LC',
    },
    {
      name: 'Saint Martin',
      id: 245,
      abbreviation: 'MF',
    },
    {
      name: 'Saint Vincent and the Grenadines',
      id: 185,
      abbreviation: 'VC',
    },
    {
      name: 'Sint Maarten',
      id: 247,
      abbreviation: 'SX',
    },
    {
      name: 'Suriname',
      id: 201,
      abbreviation: 'SR',
    },
    {
      name: 'Trinidad and Tobago',
      id: 214,
      abbreviation: 'TT',
    },
    {
      name: 'Turks and Caicos Islands',
      id: 218,
      abbreviation: 'TC',
    },
    {
      name: 'Uruguay',
      id: 226,
      abbreviation: 'UY',
    },
    {
      name: 'Venezuela',
      id: 230,
      abbreviation: 'VE',
    },
    {
      name: 'Virgin Islands, British',
      id: 29,
      abbreviation: 'VG',
    },
  ],
};
